var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 83,
    viewBox: "0 0 100 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90316 9.81345C6.46126 9.02212 8.0485 8.24097 9.70748 7.6551C18.9059 4.41248 28.575 3.0658 38.3092 2.15852C44.3937 1.59096 50.5162 1.31227 56.632 1.08036C66.1263 0.718261 75.596 1.07426 84.9782 2.54706C88.5114 3.10242 91.9863 3.87951 95.2078 5.39503C97.5865 6.51388 99.2051 8.14536 99.4091 10.6475C99.51 11.8904 99.501 13.1639 99.3306 14.3987C98.667 19.2117 96.9004 23.7461 94.9074 28.2154C94.1721 29.8652 90.0941 37.7683 90.0941 37.7683C90.0941 37.7683 88.5069 40.5146 87.7043 41.8795C87.6393 41.9874 86.2695 44.2047 86.1529 44.3919C84.9535 46.3325 82.4113 50.34 82.4113 50.34L75.9592 59.6387C75.9592 59.6387 74.5692 61.2152 74.3204 61.4959C70.5159 65.8004 66.8101 70.1863 62.8532 74.3728C60.1809 77.2025 57.058 79.6456 53.4777 81.5599C50.3458 83.2341 47.1646 83.4314 44.017 81.7613C42.0285 80.7055 40.0781 79.5358 38.3182 78.1932C32.7046 73.9172 28.1401 68.7664 23.8111 63.4366C23.0466 62.4948 22.3135 61.5346 21.5311 60.5419L13.8751 49.6952C11.483 45.8565 9.082 42.0219 7.15623 37.9636C7.15623 37.9636 3.42353 29.8347 3.3204 29.5723C1.77351 25.6034 0.475468 21.5817 0.376826 17.3178C0.302844 14.0162 1.69056 11.4449 4.90316 9.81142V9.81345Z",
    fill: "url(#paint0_radial_712_27793)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_712_27793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.1922 42.2098) rotate(90.3772) scale(40.7102 49.1764)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081F5C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberTag);
export default __webpack_public_path__ + "static/media/number-tag.5e4954442306b55a380540f68547237b.svg";
export { ForwardRef as ReactComponent };